// angular
import { Component } from '@angular/core';
import { CookiePref, AnalyticsService } from '@aa/common';

// local
import { AbstractQnaComponent } from '../abstract-qna.component';
import { QnaNavigationService } from '../qna-navigation.service';

@Component({
  selector: 'aa-qna-cookies',
  templateUrl: './cookies.component.html'
})
export class QnaCookiesPageComponent extends AbstractQnaComponent {

  public pendingCookiePref: CookiePref;
  constructor(navigation: QnaNavigationService, private readonly analytics: AnalyticsService) {
    super(navigation, 'Cookies');

    this.pendingCookiePref = analytics.cookiePref || 'rejected';
  }

  public get isDirty(): boolean {
    return this.pendingCookiePref !== this.analytics.cookiePref;
  }

  public setPendingCookiePref(pref: CookiePref) {
    this.pendingCookiePref = pref;
  }

  public saveCookiePref() {
    this.analytics.setCookiePref(this.pendingCookiePref);
  }
}
